// extracted by mini-css-extract-plugin
module.exports = {"paginacao":"Paginacao_paginacao__1UNmh","paginas":"Paginacao_paginas__uV0ZW","botao":"Paginacao_botao__3RO4N","ativo":"Paginacao_ativo__sfEnC","espaco":"Paginacao_espaco__1__dD"};